import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconTrashX, IconDeviceFloppy } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { openDeleteConfirmModal } from '../../Atoms/DeleteConfirmModal';
import { QuestionnaireS } from '../../Service/QuestionnaireS';
import SaveTemplateName from '../../Molecules/Document/SaveTemplateName';
import { useModalState } from '../../Molecules/Dialogs';
import { WindowContext } from '../../Service/Context/WindowContext';
import InjectableFooter from '../Navigation/phone/InjectableFooter';
import ContractEditorFooter from '../Navigation/phone/ContractEditorFooter';

interface Props {
  id: number;
  showPreview: () => void;
}

const QuestionnaireActions: FC<Props> = ({ id, showPreview }) => {
  const navigate = useNavigate();
  const { sm } = useContext(WindowContext);
  const { show, toggle } = useModalState(false);

  const deleteQuestionnaire = async () => {
    openDeleteConfirmModal({
      title: 'Fragebogen löschen?',
      description: 'Möchtest Du wirklich diesen Fragebogen löschen?',
      onConfirm: async () => {
        const removed = await QuestionnaireS.deleteQuestionnaire(id);
        if (removed) {
          navigate(-1);
        }
        return removed;
      },
    });
  };

  return (
    <>
      {sm && (
        <InjectableFooter>
          <ContractEditorFooter showPreview={showPreview} saveAsTemplate={toggle} remove={deleteQuestionnaire} />
        </InjectableFooter>
      )}
      {!sm && (
        <Menu radius="md" shadow="md" width={180} transition="slide-down" position="bottom-end">
          <Menu.Target>
            <ActionIcon>
              <IconDots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item icon={<IconDeviceFloppy size={16} />} onClick={toggle}>
              Vorlage speichern
            </Menu.Item>
            <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={deleteQuestionnaire}>
              Löschen
            </Menu.Item>
          </Menu.Dropdown>
          <SaveTemplateName entityId={id} open={show} close={toggle} documentType={undefined} />
        </Menu>
      )}
    </>
  );
};

export default QuestionnaireActions;
